<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h3 style="color: black;">{{$t('_analyse_image_en_cours_')}}</h3>
          </div>

          <div class="modal-body">
            Cette opération peut prendre quelques minutes. Les résultats apparaitont sur la carte quand ce sera terminé.
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <v-btn style="float: right; right: 5px; bottom: 30px;" @click="$emit('close')">
                {{$t('_compris_')}}
              </v-btn>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>

</template>

<script>

export default {
    name : "Traitement",
};

</script>

<style scoped>

.modal-container {
  width: 30vw;
  margin: 0px auto;
  padding: 20px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  border-radius: 0.25rem;
}
.modal-header {
  font-weight: bold;
  font-size: 1.4rem;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
.modal-body {
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>